import Swiper, { Navigation, Pagination } from "swiper"
import getElementsStartWithId from "./utilities"

/**
 * @title Initialise Swiper
 * @description Logic for handling the Vimeo players throughout the DOM
 */
function initialiseSwiper() {
  Swiper.use([Navigation, Pagination])

  const swiper = new Swiper(".swiper", {
    slidesPerView: 1.5,
    centeredSlides: true,
    spaceBetween: 20,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  })
}

export default initialiseSwiper
